import { FormEvent, FunctionComponent, useState } from "react"
import { useTypedDispatch } from "../../../app/store"
import LogoFull from "../../../components/logo-full"
import { setIsAuthenticated, setLoggedInUser } from "../authSlice"

const DemoAuth: FunctionComponent = () => {
  const dispatch = useTypedDispatch()

  const [password, setPassword] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [errors, setErrors] = useState<string[]>([])

  const correctPassword = "meseeknademo2024"

  const handleLogin = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setErrors([])
    const goodEmail =
      email.endsWith("@bain.com") || email.endsWith("@meseekna.com")
    const goodPass = password === correctPassword
    if (goodPass && goodEmail) {
      // Set a demo user with an id so AuthGate allows access
      dispatch(setLoggedInUser({
        id: 9999,
        email: email,
        firstName: "Demo",
        lastName: "User",
        role: 5, // SimulationUser
        organizationId: 1,
        userHash: "",
        token: "",
        imageUrl: "",
        createdOn: new Date().toISOString(),
        userName: email,
        status: 1,
        expire_status: 0,
        roleName: "SimulationUser",
        organizationName: "Demo Organization",
        roles: [{ roleId: 5, name: "SimulationUser" }],
      }))
      dispatch(setIsAuthenticated(true))
      // Make a webhook call to zapier at https://hooks.zapier.com/hooks/catch/3567731/3lr25sg/
      // Use https://api.ipify.org?format=json to get the IP address of the current user
      fetch("https://api.ipify.org?format=json").then((r) => {
        r.json().then((data) => {
          const ip = data.ip
          fetch("https://hooks.zapier.com/hooks/catch/3567731/3lr25sg/", {
            method: "POST",
            body: JSON.stringify({
              email,
              password,
              ip_address: ip, // Get the IP address of the current user
              created: new Date().toISOString(),
            }),
          })
        })
      })
    } else {
      if (!goodEmail) {
        setErrors((prev) => [...prev, "Invalid email"])
      }
      if (!goodPass) {
        setErrors((prev) => [...prev, "Incorrect password"])
      }
    }
  }

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[170px] px-8 pb-12 box-border items-center justify-start">
      <main className="w-[360px] flex flex-col items-center justify-start gap-[32px] text-left text-sm text-gray-900 font-text-md-regular1">
        <div className="self-stretch flex flex-col items-center justify-start gap-[24px] text-center font-text-md-regular">
          <LogoFull
            dimensions="/v3/assets/meseekna-logo@2x.png"
            logoWrapWidth="189px"
            logoWrapHeight="31.5px"
            image1Width="188.61px"
            image1Height="30.02px"
          />
          <div className="self-stretch flex flex-col items-start justify-start gap-[12px]"></div>
        </div>
        <div
          id="formErrors"
          className="self-stretch flex flex-col items-start justify-start gap-[12px]">
          {errors.map((error) => (
            <div key={error} className="text-red-500">
              {error}
            </div>
          ))}
        </div>
        <form onSubmit={handleLogin}>
          <div className="self-stretch rounded-xl flex flex-col items-center justify-start gap-[24px] text-gray-700">
            <div className="relative w-full flex flex-col items-start justify-start gap-[6px] text-left text-sm text-gray-700 font-text-md-regular1">
              <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
                <label htmlFor="authGateEmail">Email</label>
                <input
                  id="authGateEmail"
                  className="self-stretch rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-3.5 items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid border-gray-300"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Email"
                />
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
                <label htmlFor="authGatePassword">Password</label>
                <input
                  id="authGatePassword"
                  className="self-stretch rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-3.5 items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid border-gray-300"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                />
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
                <button
                  type="submit"
                  className="cursor-pointer [border:none] p-0 mt-8 bg-[transparent] self-stretch flex flex-col items-start justify-start">
                  <div className="self-stretch rounded-lg bg-primary-600 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-[18px] items-center justify-center gap-[8px] border-[1px] border-solid border-primary-600">
                    <div className="flex-1 relative text-base leading-[28px] font-semibold font-text-md-regular1 text-base-white text-center">
                      Submit
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </form>
      </main>
    </div>
  )
}

export default DemoAuth
